import { createSelector } from 'redux-bundler';
import errorsExist from 'utils/errorsExist';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';

import { READ_BOARD } from '../constants';

export const reactReadBoardDetails = createSelector(
  'selectIsLoggedIn',
  'selectBoardsById',
  'selectUrlParams',
  'selectFreshCurrentOrganizationBoards',
  'selectFreshCurrentBoardDetails',
  'selectIsFetchingBoard',
  'selectErrors',
  (
    isLoggedIn,
    boardsById,
    { boardId },
    freshCurrentOrganizationBoards,
    freshCurrentBoardDetails,
    isFetchingBoard,
    errors,
  ) => {
    const boardErrors = errorsExist([READ_BOARD], errors);

    if (
      !isLoggedIn ||
      isFetchingBoard ||
      boardErrors ||
      !freshCurrentOrganizationBoards ||
      !boardId ||
      !isCorrectHatchIdFormat(boardId) ||
      freshCurrentBoardDetails ||
      !boardsById[boardId]
    ) {
      return false;
    }

    const workspaceId = boardsById[boardId].id;

    return {
      actionCreator: 'doReadBoard',
      args: [{ mongoId: boardId, workspaceId }],
    };
  },
);
